import React, { Component, useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../hooks";
import { setGreenhouseValues, setGreenhouses } from "../../slices/greenhouseSlice"
import {
  Box,
  Button,
  InputAdornment,
  LinearProgress,
  TextareaAutosize,
  TextField,
  Typography,
  Paper,
  Grid,
  TableCell, tableCellClasses, InputLabel
} from "@mui/material";
import TableRow from '@mui/material/TableRow';
import { GridColDef, GridValueGetterParams, GridEventListener, useGridApiRef, GridSelectionModel, GridApi, GridCellValue } from '@mui/x-data-grid';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import { deepOrange, deepPurple } from '@mui/material/colors';
import DeleteIcon from '@mui/icons-material/Delete';
import SettingsIcon from '@mui/icons-material/Settings';
import Collapse from '@mui/material/Collapse';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import TestGrid from "../../components/TestGrid";
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';
import SaveIcon from '@mui/icons-material/Save';
import PrintIcon from '@mui/icons-material/Print';
import ShareIcon from '@mui/icons-material/Share';
import PropTypes from "prop-types";
import NewGreenhouse from "../../components/NewGreenhouse";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import axios from "axios";
import { IGreenhouse, IGreenhouseState } from "../../interfaces/IGreenhouse";
import { IBay } from "../../interfaces/IBay";
import { IZone } from "../../interfaces/IZone";
import { IBench } from "../../interfaces/IBench";
import { ITray } from "../../interfaces/ITray";
import { GridRowParams, useGridApiEventHandler, useGridApiContext } from "@mui/x-data-grid";
import SupportIcon from '@mui/icons-material/ContactSupport';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import { Checkbox, FormControlLabel, FormHelperText } from "@mui/material";
import { useForm, FormProvider, useFormContext, UseFormRegister, SubmitHandler } from "react-hook-form";
import { alpha, styled } from '@mui/material/styles';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import ConfirmDialog, { confirmDialog } from "../../components/ConfirmDialog";
import { setPageTitle } from "../../slices/applicationSlice";
import { setSelectionValues } from "../../slices/selectionSlice";
import { IApplication } from "../../interfaces/IApplication";
import MovementDialog from "../../components/MovementDialog";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import UploadIcon from '@mui/icons-material/Upload';
import { ISelection } from "../../interfaces/ISelection";


const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
  [`& .${gridClasses.row}.even`]: {
    backgroundColor: theme.palette.grey[300],
    '&:hover, &.Mui-hovered': {
      backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
    '&.Mui-selected': {
      backgroundColor: alpha(
        theme.palette.primary.main,
        ODD_OPACITY + theme.palette.action.selectedOpacity,
      ),
      '&:hover, &.Mui-hovered': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          ODD_OPACITY +
          theme.palette.action.selectedOpacity +
          theme.palette.action.hoverOpacity,
        ),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: alpha(
            theme.palette.primary.main,
            ODD_OPACITY + theme.palette.action.selectedOpacity,
          ),
        },
      },
    },
  },
}));




const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const actions = [
  { icon: <FileCopyIcon />, name: 'Copy' },
  { icon: <SaveIcon />, name: 'Save' },
  { icon: <PrintIcon />, name: 'Print' },
  { icon: <ShareIcon />, name: 'Share' },
];

function createData(
  name: string,
  calories: number,
  fat: number,
  carbs: number,
  protein: number,
  price: number,
) {
  return {
    name,
    calories,
    fat,
    carbs,
    protein,
    price,
    history: [
      {
        date: '2020-01-05',
        customerId: '11091700',
        amount: 3,
      },
      {
        date: '2020-01-02',
        customerId: 'Anonymous',
        amount: 1,
      },
    ],
  };
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

type Anchor = 'top' | 'left' | 'bottom' | 'right';

type Props = {
  showActionMenu: boolean,
  setSelectedTrays?: React.Dispatch<React.SetStateAction<ITray[]>>,
  setTitle?: boolean | undefined,
  setSelectionModel: React.Dispatch<React.SetStateAction<GridSelectionModel>>
}

export function GreenhouseTraySelection(props: Props) {
  const dispatch = useAppDispatch();
  const {setSelectionModel} = props;
  var applicationState: IApplication = {
    pageTitle: "Greenhouse Management",
    backgroundPath: "/assets/images/spaceallocationbg.jpg"
  }

  var selectionState: ISelection = {
    selection: []
  }
  const [movementTitle, setMovementTitle] = useState("");
  const [movementObject, setMovementObject] = useState<IGreenhouse | IBay | IZone | IBench>();
  const [movementType, setMovementType] = useState<any>();

  // useEffect(() => {
  //   // setSelectionModel(internalSelectionModel);
  // }, [internalSelectionModel])

  if (props.setTitle == true || props.setTitle == undefined) {
    dispatch(setPageTitle(applicationState));
  }
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_ENDPOINT}/api/Greenhouses`)
      .then(res => {
        var greenhouseResult: IGreenhouseState = {
          greenhouse: null,
          greenhouses: res.data
        }
        dispatch(setGreenhouses(greenhouseResult));
      });
  }, []);

  const { handleSubmit: handleBaySubmit, register: bayRegister, reset: bayReset, setValue: setBayValue, getValues: getBayValues } = useForm<IBay>();
  const onBaySubmit: SubmitHandler<IBay> = async data => {
    data.greenhouseID = currentGreenhouse?.id!;
    let bayData = await submitBay(data);
    console.log("BAY DATA", bayData);
    handleBayClose();
    if (bayData) {
      let updatedBays = bays.filter(i => i.id === bayData.id).length > 0 ? bays.map(obj => obj.id === bayData.id ? bayData : obj) : [...bays, bayData!]
      setBays(updatedBays);
    }
    bayReset();
  };

  const submitBay = async (data: IBay): Promise<IBay> => {
    console.log("IN SUBMIT BAY", data);
    if (data.id == 0) {
      let bayData = axios.post<IBay>(`${process.env.REACT_APP_ENDPOINT}/api/Bays/`, data)
        .then(x => { return x.data });
      return bayData;
    } else {
      let bayData = axios.put<IBay>(`${process.env.REACT_APP_ENDPOINT}/api/Bays/${data.id}`, data)
        .then(x => { return x.data });
      return bayData;
    }
  }

  const { handleSubmit: handleZoneSubmit, register: zoneRegister, reset: zoneReset, setValue: setZoneValue, getValues: getZoneValues } = useForm<IZone>();
  const onZoneSubmit: SubmitHandler<IZone> = async data => {
    data.bayID = currentBay?.id!;
    let zoneData = await submitZone(data);
    handleZoneClose();
    if (zoneData) {
      let updatedZones = zones.filter(i => i.id === zoneData.id).length > 0 ? zones.map(obj => obj.id === zoneData.id ? zoneData : obj) : [...zones, zoneData!]
      setZones(updatedZones);
    }
    zoneReset();
  };

  const submitZone = async (data: IZone): Promise<IZone> => {
    console.log("IN SUBMIT ZONE", data);
    if (data.id == 0) {
      let zoneData = axios.post<IZone>(`${process.env.REACT_APP_ENDPOINT}/api/Zones/`, data)
        .then(x => { return x.data });
      return zoneData;
    } else {
      let zoneData = axios.put<IZone>(`${process.env.REACT_APP_ENDPOINT}/api/Zones/${data.id}`, data)
        .then(x => { return x.data });
      return zoneData;
    }
  }

  const { handleSubmit: handleBenchSubmit, register: benchRegister, reset: benchReset, setValue: setBenchValue, getValues: getBenchValues } = useForm<IBench>();
  const onBenchSubmit: SubmitHandler<IBench> = async data => {
    data.zoneID = currentZone?.id!;
    let benchData = await submitBench(data);
    console.log("GR DATA", benchData);
    handleBenchClose();
    if (benchData) {
      let updatedBenches = benches.filter(i => i.id === benchData.id).length > 0 ? benches.map(obj => obj.id === benchData.id ? benchData : obj) : [...benches, benchData!]
      setBenches(updatedBenches);
    }
    benchReset();
  };

  const submitBench = async (data: IBench): Promise<IBench> => {
    console.log("IN SUBMIT BAY", data);
    if (data.id == 0) {
      let bayData = axios.post<IBench>(`${process.env.REACT_APP_ENDPOINT}/api/Benches/`, data)
        .then(x => { return x.data });
      return bayData;
    } else {
      let bayData = axios.put<IBench>(`${process.env.REACT_APP_ENDPOINT}/api/Benches/${data.id}`, data)
        .then(x => { return x.data });
      return bayData;
    }
  }


  const fetchedGreenhouses = useAppSelector((state) => state.greenhouses);
  const fetchedSelection = useAppSelector((state) => state.selection);
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        if (
          event &&
          event.type === 'keydown' &&
          ((event as React.KeyboardEvent).key === 'Tab' ||
            (event as React.KeyboardEvent).key === 'Shift')
        ) {
          return;
        }

        setState({ ...state, [anchor]: open });
      };

  const Input = styled('input')({
    display: 'none'
  })

  const handleFileSelected = (e: React.ChangeEvent<HTMLInputElement>): void => {
    console.log("Hello!");
    if (e.target.files != null) {
      const files = Array.from(e.target.files);
      const headers = {
        'Content-Type': 'multipart/form-data'
      }
      var bodyFormData = new FormData();
      bodyFormData.append('files', files[0]);
      axios.post(`${process.env.REACT_APP_ENDPOINT}/api/Greenhouses/Upload`, bodyFormData, {
        headers: headers
      });
    }
  }

  const list = (anchor: Anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 350 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}>
      <Grid container spacing={0}>
        <Grid item xs={9}>
          <Typography variant='h5' m={2}>Action Menu</Typography>
        </Grid>
        <Grid item xs={2}>
          <IconButton
            size="large"
            aria-label="show more"
            aria-haspopup="true"
            onClick={handleClickHelpOpen}
            color="inherit"
          >
            <SupportIcon sx={{ fontSize: '50px' }} />
          </IconButton>
        </Grid>
      </Grid>
      <Grid container spacing={1} padding={2}>
        <Grid item xs={12}>
          <Button startIcon={<AddCircleIcon style={{ width: '35px', height: '35px' }} />} variant="contained" color="primary" fullWidth sx={{ height: '150px', padding: '3' }} onClick={handleClickOpen}>
            <Typography variant="h6" color="#FFF" textAlign="left" fontWeight={600}>Add New Greenhouse</Typography>
          </Button>
        </Grid>
        <Grid item xs={12}>
          <input
            accept="application/JSON"
            style={{ display: 'none' }}
            id="raised-button-file"
            multiple
            type="file"
            onChange={handleFileSelected}
          />
          <label htmlFor="raised-button-file">
            <Button startIcon={<UploadIcon style={{ width: '35px', height: '35px' }} />} variant="contained" component="span" color="primary" fullWidth sx={{ height: '150px', padding: '3' }}>
              <Typography variant="h6" color="#FFF" textAlign="left" fontWeight={600}>Import Greenhouse</Typography>
            </Button>
          </label>
        </Grid>
      </Grid>
    </Box>
  );

  const [open, setOpen] = React.useState(false);
  const [importOpen, setImportOpen] = React.useState(false);
  const [trayOpen, setTrayOpen] = React.useState(false);
  const [movementOpen, setMovementOpen] = React.useState(false);
  const [helpOpen, setHelpOpen] = React.useState(false);
  const [bayOpen, setBayOpen] = React.useState(false);
  const [zoneOpen, setZoneOpen] = React.useState(false);
  const [benchOpen, setBenchOpen] = React.useState(false);
  const [greenhouseOpen, setGreenhouseOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleImportOpen = () => {
    setImportOpen(true);
  };

  const handleClickHelpOpen = () => {
    setHelpOpen(true);
  };

  const handleHelpClose = () => {
    setHelpOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleImportClose = () => {
    setImportOpen(false);
  };

  const handleBayOpen = () => {
    setBayOpen(true);
  };

  const handleBayClose = () => {
    setBayOpen(false);
  };

  const handleZoneOpen = () => {
    setZoneOpen(true);
  };

  const handleZoneClose = () => {
    setZoneOpen(false);
  };

  const handleBenchOpen = () => {
    setBenchOpen(true);
  };

  const handleBenchClose = () => {
    setBenchOpen(false);
  };

  const handleTrayClose = () => {
    console.log("Tray Closed?");
    setTrayOpen(false);
  }

  const handleMovementClose = () => {
    console.log("Movement Closed?");
    setMovementOpen(false);
  }

  const handleGreenhouseOpen = () => {
    setGreenhouseOpen(true);
  };

  const handleGreenhouseClose = () => {
    setGreenhouseOpen(false);
  };

  const columns: GridColDef[] = [
   // { field: 'id', headerName: 'ID', width: 70 },
    { field: 'name', headerName: 'Name', width: 130 },
    { field: 'description', headerName: 'Description', width: 130 },
    
  ];

  const bayColumns: GridColDef[] = [
    //{ field: 'id', headerName: 'ID', width: 70 },
    { field: 'name', headerName: 'Name', width: 130 },
    { field: 'description', headerName: 'Description', width: 130 },
    
  ];

  const zoneColumns: GridColDef[] = [
    //{ field: 'id', headerName: 'ID', width: 70 },
    { field: 'name', headerName: 'Name', width: 130 },
    { field: 'description', headerName: 'Description', width: 130 },
    {
      field: "action",
      headerName: "Action",
      width: 250,
      sortable: false,
      renderCell: (params) => {
        const onClick = (e: any) => {
          e.stopPropagation(); // don't select this row after clicking

          const api: GridApi = params.api;
          const thisRow: Record<string, GridCellValue> = {};

          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach(
              (c) => (thisRow[c.field] = params.getValue(params.id, c.field))
            );

          let zone = zones.find(x => x.id == thisRow.id);
          zoneReset(zone);
          handleZoneOpen();
        };

        const moveOnClick = (e: any) => {
          e.stopPropagation(); // don't select this row after clicking

          const api: GridApi = params.api;
          const thisRow: Record<string, GridCellValue> = {};

          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach(
              (c) => (thisRow[c.field] = params.getValue(params.id, c.field))
            );

          let zone = zones.find(x => x.id == thisRow.id);
          setMovementTitle(`MOVE ZONE: ${zone?.name.toUpperCase()} `);
          setMovementObject(zone);
          setMovementType("zone");
          setMovementOpen(true);
        };

        return <Grid>
         
        </Grid>
      }
    },
  ];

  const benchColumns: GridColDef[] = [
   // { field: 'id', headerName: 'ID', width: 70 },
    { field: 'name', headerName: 'Name', width: 130 },
    { field: 'description', headerName: 'Description', width: 130 },
    {
      field: "action",
      headerName: "Action",
      width: 300,
      sortable: false,
      renderCell: (params) => {
        const onClick = (e: any) => {
          e.stopPropagation(); // don't select this row after clicking

          const api: GridApi = params.api;
          const thisRow: Record<string, GridCellValue> = {};

          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach(
              (c) => (thisRow[c.field] = params.getValue(params.id, c.field))
            );

          let bench = benches.find(x => x.id == thisRow.id);
          console.log("BENCH", bench);
          benchReset(bench);
          handleBenchOpen();
        };

        const moveOnClick = (e: any) => {
          e.stopPropagation(); // don't select this row after clicking

          const api: GridApi = params.api;
          const thisRow: Record<string, GridCellValue> = {};

          api
            .getAllColumns()
            .filter((c) => c.field !== "__check__" && !!c)
            .forEach(
              (c) => (thisRow[c.field] = params.getValue(params.id, c.field))
            );

          let bench = benches.find(x => x.id == thisRow.id);
          setMovementTitle(`MOVE BENCH: ${bench?.name.toUpperCase()} `);
          setMovementObject(bench);
          setMovementType("bench");
          setMovementOpen(true);
        };

        return <Grid>
         
        </Grid>
      }
    },
  ];

  const trayColumns: GridColDef[] = [
   // { field: 'id', headerName: 'ID', width: 70 },
    { field: 'name', headerName: 'Name', width: 250 },
    { field: 'description', headerName: 'Description', width: 350 },
    { field: 'species', headerName: 'Species', width: 300 },
    { field: 'variety', headerName: 'Variety', width: 250 },
    { field: 'color', headerName: 'Color', width: 200 },
  ];

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: "transparent",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: '#191919',
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
  }));

  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#89B219',
      },
    },
  });

  type AccordianProps = {
    id: number,
    name: string,
    bays: IBay[]
  }

  const [openAccordianId, setOpenAccordianId] = useState(0);
  const [currentGreenhouse, setCurrentGreenhouse] = useState<IGreenhouse>();
  const [bays, setBays] = useState<IBay[]>([]);
  const [selectedBays, setSelectedBays] = useState<IBay[]>([]);
  const [currentBay, setCurrentBay] = useState<IBay>();
  const [zones, setZones] = useState<IZone[]>([]);
  const [currentZone, setCurrentZone] = useState<IZone>();
  const [benches, setBenches] = useState<IBench[]>([]);
  const [currentBench, setCurrentBench] = useState<IBench>();
  const [trays, setTrays] = useState<ITray[]>([]);
  const [currentTrays, setCurrentTrays] = useState<ITray[]>([]);

  const CustomAccordian = ({ id, name }: AccordianProps) => {
    const handleBayRowClick: GridEventListener<'rowClick'> = (params) => {
      let bay = bays.find(x => x.id === params.row.id);
      if (bay !== undefined) {
        setCurrentBay(bay);
        setZones(bay.zones);
        setValue(1);
      };
    };

    const handleZoneRowClick: GridEventListener<'rowClick'> = (params) => {
      let zone = zones.find(x => x.id === params.row.id);
      if (zone !== undefined) {
        setCurrentZone(zone);
        setBenches(zone.benches)
        setValue(2);
      };
    };

    const handleBenchRowClick: GridEventListener<'rowClick'> = (params) => {
      let bench = benches.find(x => x.id === params.row.id);
      if (bench !== undefined) {
        setCurrentBench(bench);
        setTrays(bench.trays)
        setValue(3);
      };
    };

    return (
      <Accordion key={id} expanded={id === openAccordianId} disableGutters >
        <AccordionSummary onClick={() => {
          openAccordianId !== id ? setOpenAccordianId(id) : setOpenAccordianId(0);
          let greenhouse = fetchedGreenhouses.greenhouses.find(x => x.id === id);
          setZones([]);
          setBenches([]);
          setTrays([]);
          setValue(0);
          setCurrentGreenhouse(undefined);
          setCurrentBay(undefined);
          setCurrentZone(undefined);
          setCurrentBench(undefined);
          if (greenhouse != undefined) {
            setCurrentGreenhouse(greenhouse);
            setBays(greenhouse.bays);
          }
        }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          sx={{ backgroundImage: 'linear-gradient(#BBB, #FFF);' }}
        >
          <Grid container spacing={2}>
            <Grid item xs={10}>
              <Stack direction="row" spacing={2}>
                <Avatar sx={{ backgroundColor: 'darkblue' }}>{name.slice(0, 2)}</Avatar>
                <Item><Typography variant='h5' fontWeight={600} textAlign='left'>{name}</Typography></Item>
              </Stack>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails >
          <Grid item xs={4} sx={{ marginBottom: 1 }}>
            <Stack direction="row" spacing={2}>
             
            </Stack>
          </Grid>
          <Box sx={{ width: '100%', paddingtop: '0' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" sx={{ paddingtop: '0' }}>
                <Tab label="Bays" {...a11yProps(0)} />
                <Tab label="Zones" disabled={currentBay === undefined} {...a11yProps(1)} />
                <Tab label="Benches" disabled={currentZone === undefined} {...a11yProps(2)} />
                <Tab label="Trays" disabled={currentBench === undefined} {...a11yProps(3)} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <Grid container spacing={2}>
                <Grid item>
                  <Button variant="contained" color="secondary" sx={{ marginY: 2 }} onClick={() => { bayReset({}); handleBayOpen(); }}>CREATE NEW BAY</Button>
                </Grid>
              </Grid>
              <div style={{ height: 'calc(90vh - 145px)', width: '100%' }}>
                <StripedDataGrid
                  rows={bays}
                  onRowClick={handleBayRowClick}
                  disableSelectionOnClick
                  columns={bayColumns}
                  pageSize={15}
                  rowsPerPageOptions={[15]}
                  checkboxSelection
                  sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                  }
                />
              </div>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <Grid container spacing={2}>
                <Grid item>
                  <Button variant="contained" color="secondary" sx={{ marginY: 2 }} onClick={() => { zoneReset({}); handleZoneOpen(); }}>CREATE NEW ZONE</Button>
                </Grid>
              </Grid>
              <div style={{ height: 'calc(90vh - 145px)', width: '100%' }}>
                <StripedDataGrid
                  rows={zones}
                  onRowClick={handleZoneRowClick}
                  columns={zoneColumns}
                  pageSize={15}
                  rowsPerPageOptions={[15]}
                  checkboxSelection
                  sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                  }
                />
              </div>
            </TabPanel>
            <TabPanel value={value} index={2}>
              <Grid container spacing={2}>
                <Grid item>
                  <Button variant="contained" color="secondary" sx={{ marginY: 2 }} onClick={() => { benchReset({}); handleBenchOpen(); }}>CREATE NEW BENCH</Button>
                </Grid>
              </Grid>
              <div style={{ height: 'calc(90vh - 145px)', width: '100%' }}>
                <StripedDataGrid
                  rows={benches}
                  onRowClick={handleBenchRowClick}
                  disableSelectionOnClick
                  columns={benchColumns}
                  pageSize={15}
                  rowsPerPageOptions={[15]}
                  checkboxSelection
                  sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                  }
                />
              </div>
            </TabPanel>
            <TabPanel value={value} index={3}>
              <div style={{ height: 'calc(90vh - 145px)', width: '100%' }}>
                <StripedDataGrid
                  rows={trays}
                  columns={trayColumns}
                  pageSize={15}
                  rowsPerPageOptions={[15]}
                  checkboxSelection
                  onSelectionModelChange={(newSelectionModel) => {
                    dispatch(setSelectionValues({selection: newSelectionModel}))
                  }}
                  keepNonExistentRowsSelected
                  selectionModel={fetchedSelection.selection}
                  sx={{ borderColor: 'rgba(100,100,100,0.2)' }}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                  }
                />
              </div>
            </TabPanel>
          </Box>
        </AccordionDetails>
      </Accordion>
    )
  };

  const styles = {
    hidden: {
      display: "none",
    },
    importLabel: {
      color: "black",
    },
  };

  const onInputChange = ({ target }: any) => {
    console.log(target.files[0])
  }

  return (
    <div>
      {props.showActionMenu && (['right'] as const).map((anchor) => (
        <React.Fragment key={anchor}>
          <Fab color='success' onClick={toggleDrawer(anchor, true)} sx={{
            margin: 0,
            top: 'auto',
            right: 40,
            bottom: 40,
            left: 'auto',
            position: 'fixed',
          }}><AddIcon /></Fab>
          <ThemeProvider theme={darkTheme}>
            <SwipeableDrawer
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer(anchor, false)}
              onOpen={toggleDrawer(anchor, true)}
              variant="persistent"
              ModalProps={{
                keepMounted: true
              }}
            >
              {list(anchor)}
            </SwipeableDrawer>
          </ThemeProvider>
        </React.Fragment>
      ))}

      <Grid container spacing={0} >
        <Grid item xs={12}>
          <div style={{ height: '90vh', width: '100%' }}>
            {fetchedGreenhouses.greenhouses.map((item, index) => {
              return <CustomAccordian id={item.id} key={item.id} name={item.name} bays={item.bays}></CustomAccordian>
            })}
          </div>
        </Grid>
      </Grid>


      <Dialog open={open} onClose={handleClose} maxWidth='xl' fullWidth>
        <DialogContent>
          <NewGreenhouse setOpen={setOpen}></NewGreenhouse>
        </DialogContent>
      </Dialog>

      <MovementDialog title={movementTitle} source={movementObject} sourceType={movementType} isOpen={movementOpen} handleClose={handleMovementClose}></MovementDialog>


      <BootstrapDialog
        onClose={handleGreenhouseClose}
        aria-labelledby="customized-dialog-title"
        open={greenhouseOpen}
        maxWidth='lg' fullWidth
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleGreenhouseClose}>
          Edit Greenhouse
        </BootstrapDialogTitle>
        <Box component="form">
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Greenhouse Name"
                  placeholder="Greenhouse XYZ"
                  type="text"
                /* {...register("greenhouseName")} */
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Greenhouse Description"
                  placeholder="N/W Garden"
                  type="text"
                /* {...register("greenhouseDescription")} */
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Length (FT)"
                  placeholder="20.1"
                  type="number"
                /* {...register("greenhouseLength")} */
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Width (FT)"
                  placeholder="15.5"
                  type="number"
                /* {...register("greenhouseWidth")} */

                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Total Space (SQFT)"
                  placeholder="15.5"
                  type="number"
                  defaultValue={0}
                /* {...register("greenhouseSize")} */
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Last Updated"
                  type="date"
                /* {...register("greenhouseLastUpdated")} */
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Percent Allocated Space (%)"
                  placeholder="15.5"
                  type="number"
                  disabled
                /* {...register("greenhouseAllocatedSpace")} */
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Percent Available Space (%)"
                  placeholder="15.5"
                  type="number"
                  disabled
                /*  {...register("greenhouseAvailableSpace")} */
                />
              </Grid>
              <Grid item xs={2}>
                <FormControlLabel
                  label="Heated Floors?"
                  control={
                    <Checkbox sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }} /* {...register("greenhouseHeatedFloors")} */ />
                  }
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button autoFocus color='primary' variant='contained' onClick={() => confirmDialog("Are you sure you want to save these changes?", handleBaySubmit(onBaySubmit))}>
              Save Changes
            </Button>
          </DialogActions>
          <ConfirmDialog />
        </Box>
      </BootstrapDialog>


      <BootstrapDialog
        onClose={handleGreenhouseClose}
        aria-labelledby="customized-dialog-title"
        open={bayOpen}
        maxWidth='lg' fullWidth
      >

        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleBayClose}>
          Add New Bay
        </BootstrapDialogTitle>
        <Box component="form">
          <DialogContent dividers>
            <Grid container spacing={2}>
              <TextField
                sx={{ display: 'none' }}
                fullWidth
                label="ID"
                type="number"
                defaultValue={0}
                {...bayRegister("id")}
              />
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Bay Name"
                  placeholder="Bay XYZ"
                  type="text"
                  {...bayRegister("name")}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Description"
                  placeholder="Bay 1/2/3"
                  type="text"
                  {...bayRegister("description")}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Length"
                  placeholder="20.1"
                  type="number"
                  {...bayRegister("length", {
                    valueAsNumber: true,
                    onChange: (evt) => {
                      const [width] = getBayValues(['width'])
                      const calculatedSize = (parseFloat(evt.target.value) * width);
                      if (!isNaN(calculatedSize)) {
                        setBayValue('size', calculatedSize)
                      }
                    }
                  })}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Width"
                  placeholder="15.5"
                  type="number"
                  {...bayRegister("width", {
                    valueAsNumber: true,
                    onChange: (evt) => {
                      const [length] = getBayValues(['length'])
                      const calculatedSize = (parseFloat(evt.target.value) * length);
                      if (!isNaN(calculatedSize)) {
                        setBayValue('size', calculatedSize)
                      }
                    }
                  })}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Total Size"
                  placeholder="5000"
                  type="number"
                  defaultValue={0}
                  disabled
                  {...bayRegister("size")}
                />
              </Grid>
              <Grid item xs={2}>
                <FormControlLabel
                  label="Growing Lights?"
                  control={
                    <Checkbox {...bayRegister("isGrowLights")} sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }} />
                  }
                />
              </Grid>
              <Grid item xs={2}>
                <FormControlLabel
                  label="Germination?"
                  control={
                    <Checkbox {...bayRegister("isGermination")} sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }} />
                  }
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button autoFocus color='primary' variant='contained' onClick={() => confirmDialog("Are you sure you want to save these changes?", handleBaySubmit(onBaySubmit))}>
              Save Changes
            </Button>
          </DialogActions>
          <ConfirmDialog />
        </Box>
      </BootstrapDialog>



      <BootstrapDialog
        onClose={handleZoneClose}
        aria-labelledby="customized-dialog-title"
        open={zoneOpen}
        maxWidth='lg' fullWidth
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleZoneClose}>
          Add New Zone
        </BootstrapDialogTitle>
        <Box component="form" onSubmit={handleZoneSubmit(onZoneSubmit)}>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <TextField
                sx={{ display: 'none' }}
                fullWidth
                label="ID"
                type="number"
                defaultValue={0}
                {...zoneRegister("id")}
              />
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Zone Name"
                  placeholder="Zone Blue"
                  type="text"
                  {...zoneRegister("name")}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Description"
                  placeholder="Zone 1/2/3"
                  type="text"
                  {...zoneRegister("description")}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Length"
                  placeholder="20.1"
                  type="number"
                  defaultValue={0}
                  {...zoneRegister("length", {
                    valueAsNumber: true,
                    onChange: (evt) => {
                      const [width] = getZoneValues(['width'])
                      const calculatedSize = (parseFloat(evt.target.value) * width);
                      if (!isNaN(calculatedSize)) {
                        setZoneValue('size', calculatedSize)
                      }
                    }
                  })}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Width"
                  placeholder="15.5"
                  type="number"
                  defaultValue={0}
                  {...zoneRegister("width", {
                    valueAsNumber: true,
                    onChange: (evt) => {
                      const [length] = getZoneValues(['length'])
                      const calculatedSize = (parseFloat(evt.target.value) * length);
                      if (!isNaN(calculatedSize)) {
                        setZoneValue('size', calculatedSize)
                      }
                    }
                  })}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button autoFocus color='primary' variant='contained' type="submit" onClick={() => confirmDialog("Are you sure you want to save these changes?", handleZoneSubmit(submitZone))}>
              Save Changes
            </Button>
          </DialogActions>
          <ConfirmDialog />
        </Box>
      </BootstrapDialog>


      <BootstrapDialog
        onClose={handleBenchClose}
        aria-labelledby="customized-dialog-title"
        open={benchOpen}
        maxWidth='lg' fullWidth
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleBenchClose}>
          Add New Bench
        </BootstrapDialogTitle>
        <Box component="form" onSubmit={handleBenchSubmit(onBenchSubmit)}>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <TextField
                sx={{ display: 'none' }}
                fullWidth
                label="ID"
                type="number"
                defaultValue={0}
                {...benchRegister("id")}
              />
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Bench Name"
                  placeholder="Bench N/W Green"
                  type="text"
                  {...benchRegister("name")}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Description"
                  placeholder="Bench 1/2/3"
                  type="text"
                  {...benchRegister("description")}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Length"
                  placeholder="20.1"
                  type="number"
                  defaultValue={0}
                  {...benchRegister("length", {
                    valueAsNumber: true,
                    onChange: (evt) => {
                      const [width] = getBenchValues(['width'])
                      const calculatedSize = (parseFloat(evt.target.value) * width);
                      if (!isNaN(calculatedSize)) {
                        setBenchValue('size', calculatedSize)
                      }
                    }
                  })}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Width"
                  placeholder="15.5"
                  type="number"
                  defaultValue={0}
                  {...benchRegister("width", {
                    valueAsNumber: true,
                    onChange: (evt) => {
                      const [length] = getBenchValues(['length'])
                      const calculatedSize = (parseFloat(evt.target.value) * length);
                      if (!isNaN(calculatedSize)) {
                        setBenchValue('size', calculatedSize)
                      }
                    }
                  })}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Tray Capacity"
                  placeholder="32"
                  type="number"
                  defaultValue={0}
                  {...benchRegister("trayCapacity")}

                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button autoFocus color='primary' variant='contained' type="submit" onClick={() => confirmDialog("Are you sure you want to save these changes?", handleBenchSubmit(submitBench))}>
              Save Changes
            </Button>
          </DialogActions>
          <ConfirmDialog />
        </Box>
      </BootstrapDialog>

    </div >

  );
}

export const MemoizedSelection = React.memo(GreenhouseTraySelection);
